import React, { useEffect, useState, useCallback } from "react";

import { Button, MenuItem, Select } from "@mui/material";
import "./LogsScreen.css";
import Paginations from "@mui/material/Pagination";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../../../../../../providers/TranslationProvider";
import { mdmRegistry } from "../../../../../../../features/mdm/mdmRegistry";
import {
  DomainValueConfig,
  DomainValue,
} from "../../../../../../../services/mdmService/types";
import { ChannelkartNetworkGet } from "../../../../../../../services/networkService";
import { getMetaDataConfig } from "../../../../../../../services/uiConfigService";
import {
  dropDownElements,
  logsPerPage,
} from "../../../../../../logsAndReports/constant";
import ReportAndLogsRow from "../../../../../../logsAndReports/reportAndLogsRow";
import { LogEntity } from "../../../../../../logsAndReports/reportAndLogsRowTypes";
import StudioLogsRow from "./studioLogsRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

interface MDMstudioLogsProps {
  currentMaster: DomainValue | undefined;
  handleScreenSwitch: (screen: "default" | "logs" | "edit") => void;
  headingTitle: string;
  curData: LogEntity[]; 
  setData:  React.Dispatch<React.SetStateAction<LogEntity[]>>  ;
  filteredData:LogEntity[] ; 
  setFilteredData: React.Dispatch<React.SetStateAction<LogEntity[]>> ;
}

const CUR_COMPONENT = "Report And Logs";
const CUR_COMPONENT_COMMON = "commonPortal";
const MDMstudioLogs = (props: MDMstudioLogsProps) => {
  // const [curData, setData] = useState<LogEntity[]>([]);
  // const [filteredData, setFilteredData] = useState<LogEntity[]>([]); // To store the search results
  // const [entity, setEntity] = useState<string>(
  //   props.currentMaster?.entity ?? "All"
  // );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchQuery, setSearchQuery] = useState<string>(""); // Search query state

  // const getLogs = useCallback(async () => {
  //   const Url = getUrl(entity);
  //   const entityData = await ChannelkartNetworkGet(Url);
  //   const logs = entityData.data.features.filter(
  //     (log: any) => log.response !== undefined
  //   );
  //   setData(logs);
  //   setFilteredData(logs); // Initially set filtered data as the full data set
  // }, [entity]);

  // function getUrl(entity: string) {
  //   if (entity && entity !== "All") {
  //     return `/tasks/data?filter=type[in]:['blobcreater','mdmupload'] and attributes.entityName:${entity}&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
  //   } else {
  //     return `/tasks/data?filter=type[in]:['blobcreater','mdmupload']&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
  //   }
  // }

  // Filter logs based on search query
  const handleSearch = () => {
    const lowercasedQuery = searchQuery.toLowerCase();

    const filteredLogs = props.curData.filter((log) => {
      return (
        log?.attributes?.filePath?.toLowerCase().includes(lowercasedQuery) ||
        log?.attributes?.entityName?.toLowerCase().includes(lowercasedQuery) ||
        log?.attributes?.type?.toLowerCase().includes(lowercasedQuery) ||
        (log?.response?.status &&
          typeof log.response.status === "string" &&
          log.response.status.toLowerCase().includes(lowercasedQuery)) ||
        (log?.response?.info?.error &&
          log.response.info.error[0]?.summary &&
          typeof log.response.info.error[0].summary === "string" &&
          log.response.info.error[0].summary
            .toLowerCase()
            .includes(lowercasedQuery)) ||
        (log?.response?.info?.error &&
          log.response.info.error[0]?.description &&
          typeof log.response.info.error[0].description === "string" &&
          log.response.info.error[0].description
            .toLowerCase()
            .includes(lowercasedQuery))
      );
    });

    props.setFilteredData(filteredLogs); // Update the filtered data state
  };

  // useEffect(() => {
  //   getLogs();
  // }, [getLogs]);

  const lastLogIndex = currentPage * logsPerPage - 1;
  const firstLogIndex = (currentPage - 1) * logsPerPage;
  const currentLog = props.filteredData.slice(firstLogIndex, lastLogIndex + 1); // Use filtered data for pagination

  const changePageNumber = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const logsAndReportsPagination = (
    totalLogs: number,
    LOGS_PER_PAGE: number
  ) => {
    const numberOfPages = Math.ceil(totalLogs / LOGS_PER_PAGE);
    const pageNumbers = [];

    for (let i = 1; i <= numberOfPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return (
    <div>
      <div className="app-bar">
        <div className="back-button">
          <Button
            onClick={() => props.handleScreenSwitch("default")}
            variant="text"
            sx={{ fontSize: "16px", color: "#434343" }}
          >
            ←
          </Button>{" "}
          <span className="title">{props.headingTitle}</span>
        </div>

        <div className="search-download">
          <div className="search-input-container">
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                handleSearch();
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            />
            <div className={`search-icon`} onClick={handleSearch}>
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                color="white"
                fontSize={"10px"}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="logs-screen-table">
        <div className="studio-reports-logs">
          <div className="logs-body">
            {currentLog.length > 0 ? (
              currentLog.map((currentLog, index) => {
                return (
                  <StudioLogsRow
                    key={index} // Always include a key prop when mapping
                    logIndex={index + firstLogIndex + 1}
                    id = {currentLog?.id}
                    filePath={currentLog?.attributes?.filePath}
                    lastModifiedTime={currentLog?.lastModifiedTime}
                    status={currentLog?.response?.status}
                    summary={
                      currentLog?.response?.info?.error &&
                      currentLog?.response?.info?.error[0] &&
                      currentLog?.response?.info?.error[0]?.summary
                    }
                    description={
                      currentLog?.response?.info?.error &&
                      currentLog?.response?.info?.error[0] &&
                      currentLog?.response?.info?.error[0]?.description
                    }
                    statusReport={currentLog?.response?.info?.statusReport}
                    entityName={currentLog?.attributes?.entityName}
                    type={currentLog?.attributes?.type}
                    mdmType={currentLog?.type}
                  />
                );
              })
            ) : (
              <div className="no-data-avail-msg">No Data Available</div>
            )}
          </div>

          {currentLog.length > 0 ? (
            <div className="pagination-bar">
              <Paginations
                count={
                  logsAndReportsPagination(props.filteredData.length, logsPerPage)
                    .length
                }
                page={currentPage}
                variant="outlined"
                onChange={changePageNumber}
                color="primary"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default MDMstudioLogs;
